import { useMutation, useQueryClient } from 'react-query';
import { backend } from '../axios/backend';
import { useAppContext } from '../context/AppContext';

export const useDeleteProduct = (personId?: string, options?: { onSuccess?: () => void }) => {
  const { user } = useAppContext();
  const queryClient = useQueryClient();

  return useMutation((productId: string) => backend.delete(`wish/my/${productId}`), {
    onSuccess: () => {
      queryClient.invalidateQueries(['my-wishes', user.username]);
      personId && queryClient.invalidateQueries(['ideas', personId]);
      options?.onSuccess && options.onSuccess();
    },
  });
};
